var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnowmobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 256,
    height: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.195 15.997c-.199 0-.398-.005-.599-.016L.47 14.999a.5.5 0 0 1-.417-.723l1-2a.5.5 0 0 1 .895.447l-.662 1.323 15.368.937a10.508 10.508 0 0 0 5.244-1.095l.856-.521-1.843-2.304A5.473 5.473 0 0 0 16.616 9h-.973l-3.879 2.424a.5.5 0 0 1-.529-.847l4-2.5A.487.487 0 0 1 15.5 8h1.116c1.986 0 3.836.89 5.076 2.439l2.198 2.748a.499.499 0 0 1-.131.74l-1.379.836a11.551 11.551 0 0 1-5.185 1.234z",
    fill: "current",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09 19h-7.4a1.693 1.693 0 0 1-.627-3.262l3.591-1.437a.499.499 0 1 1 .371.927l-3.591 1.437A.692.692 0 0 0 1.69 18h7.4a.91.91 0 0 0 .91-.91.905.905 0 0 0-.267-.649l-1.067-1.067a.5.5 0 0 1 .707-.707l1.067 1.067A1.912 1.912 0 0 1 9.09 19zM10.5 13h-9C.673 13 0 12.327 0 11.5S.673 10 1.5 10h9c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5zm-9-2c-.275 0-.5.225-.5.5s.225.5.5.5h9c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-9zM20 10a.5.5 0 0 1-.438-.258c-1.057-1.905-2.557-2.487-3.402-2.665l.325 1.302a.5.5 0 0 1-.97.242l-.5-2A.502.502 0 0 1 15.487 6c.136.006 3.118-.048 4.951 3.258A.5.5 0 0 1 20 10z",
    fill: "current",
    className: "color000 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17h-3a.5.5 0 0 1 0-1h2.065l-.481-.723a.5.5 0 1 1 .832-.554l1 1.5A.499.499 0 1 1 7.5 17zM21.5 19a.502.502 0 0 1-.354-.146l-3-3a.5.5 0 0 1 .707-.707l3 3A.5.5 0 0 1 21.5 19zM14.5 9.5a.5.5 0 0 1-.416-.223L13.232 8H12.5a.5.5 0 0 1 0-1h1c.167 0 .323.084.416.223l1 1.5a.5.5 0 0 1-.416.777z",
    fill: "current",
    className: "color000 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.382 19H18.5a.5.5 0 0 1 0-1h3.882a.496.496 0 0 0 .447-.275l.224-.448a.5.5 0 0 1 .895.447l-.224.447c-.255.511-.77.829-1.342.829z",
    fill: "current",
    className: "color000 svgShape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowmobile);
export default __webpack_public_path__ + "static/media/snowmobile.dbc62b357f34311798b67013111e5e90.svg";
export { ForwardRef as ReactComponent };